import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../../cc-base.component';
import {FormRichFieldConfig} from '../../../../model/api/form-rich-field-config';
import {FormFieldConfig} from '../../../../model/api/form-field-config';
import {CcSubDetailBaseComponent} from "../cc-sub-detail-base.component";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cc-readonly-rich-field[fieldName][formRichFieldConfig][formRecords]',
  templateUrl: './readonly-rich-field.component.html',
  styleUrls: ['./readonly-rich-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ]
})
export class ReadonlyRichFieldComponent extends CcSubDetailBaseComponent {

  @Input()
  formRichFieldConfig: FormRichFieldConfig;

  contextMenuConfig: MenuItem[];

  @Input()
  fieldName: String;

  @Input()
  formRecords: any[];
  @Output()
  formRecordsChange = new EventEmitter<any[]>();

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Input()
  transPartKey: string;

  fieldValueMap = {};

  dialogFormVisible: boolean;
  dialogFormTitle: string = '';

  selectedRecord: any;
  selectedRecords: any[];

  submitted: boolean;
  tableLoading: boolean;

  formRecord: any;
  editedFormRecordCopy: any;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  hideDialog() {
    this.dialogFormVisible = false;
    this.submitted = false;
    this.markForCheck();
  }

  reloadFieldValueMap() {
    this.fieldValueMap = {};
    if (this.formRichFieldConfig && this.formRichFieldConfig.tableConfigs && this.formRecords)
      this.formRichFieldConfig.tableConfigs.forEach((conf, index) => {
        if (conf.format && conf.format.includes('#'))
          conf.format = '1.0-7';
        this.formRecords.forEach((record, indexRec) => {
          if (conf.mapId) {
              this.fieldValueMap['mapId-' + index + '_' + indexRec] = conf.mapId(record);
          }
        });
      });
    super.reloadFieldValueMap();
  }
}

